import React, { Component } from 'react';
import { connect } from 'react-redux';
import './qualification.scss';
import util from '../../_helpers/util';
import classNames from 'classnames';
import Dropzone from 'react-dropzone';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { apis } from '../../actions';
import CertificateUpload from './certificateUpload/CertificateUpload';
import { CertificateType, CertificateStatus } from '../../_constants';

const step = 3;
const page = 'qualifications';

function generateRandomId() {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substr(2, 5);
  return timestamp + random;
}
class Qualification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canApply: true,
      form: {
        certification_status: '',
        qualifications: '',
        high_school: '',
        school_duration: '',
        school_taken: '',
        is_school_graduate: [],
        university: '',
        university1: '',
        degree_duration: '',
        degree_duration1: '',
        degree_taken: '',
        degree_taken1: '',
        step: step,
        addition_info: '',
        __uploadedFiles: [],
        certificates: [],
      },
      certification_status_name: '',
      files: [],
      uploadAreas: [],
    };
    this.onDrop = this.onDrop.bind(this);
    this.onAddNewUploaderArea = this.onAddNewUploaderArea.bind(this);
    this.onDeleteUploadedFile = this.onDeleteUploadedFile.bind(this);
    this.onCloseUploaderArea = this.onCloseUploaderArea.bind(this);
    this.resetFilesAfterDeletion = this.resetFilesAfterDeletion.bind(this);
  }

  findTypeId(certificateTypes, certType) {
    return certificateTypes.find((type) => type.name == certType)?.id;
  }

  statusBasedCertTypeList(certificateTypes, status) {
    const basic40Id = this.findTypeId(
      certificateTypes,
      CertificateType.BASIC40,
    );
    const s130Id = this.findTypeId(certificateTypes, CertificateType.S130);
    const s190Id = this.findTypeId(certificateTypes, CertificateType.S190);
    const l180Id = this.findTypeId(certificateTypes, CertificateType.L180);
    const femaIS100Id = this.findTypeId(
      certificateTypes,
      CertificateType.FEMA_IS100,
    );
    const femaIS700Id = this.findTypeId(
      certificateTypes,
      CertificateType.FEMA_IS700,
    );
    const rt130Id = this.findTypeId(certificateTypes, CertificateType.RT130);
    const resumeId = this.findTypeId(certificateTypes, CertificateType.RESUME);
    const fireHistoryId = this.findTypeId(
      certificateTypes,
      CertificateType.FIRE_HISTORY,
    );
    const firstAidCprId = this.findTypeId(
      certificateTypes,
      CertificateType.FIRSTAID_CPR,
    );
    const wctId = this.findTypeId(certificateTypes, CertificateType.WCT);

    let certTypeList = [];
    switch (status) {
      case CertificateStatus.NO_TRAINING:
        // Required: Resume. Optional: FEMA IS-100, FEMA IS-700, First-aid CPR
        certTypeList = [resumeId, femaIS100Id, femaIS700Id, firstAidCprId];
        break;
      case CertificateStatus.COMPLETED_BASIC_TRAINING:
        // Required: Resume, FEMA IS-100, FEMA IS-700, First-aid CPR, Basic 40 OR (S-130 + S-190 + L-180). Optional: WCT
        certTypeList = [
          resumeId,
          basic40Id,
          s130Id,
          s190Id,
          l180Id,
          femaIS100Id,
          femaIS700Id,
          firstAidCprId,
          wctId,
        ];
        break;
      case CertificateStatus.NEED_RT130:
        // Required: Resume, FEMA IS-100, FEMA IS-700, First-aid CPR, Basic 40 OR (S-130 + S-190 + L-180). Optional: WCT, fire history
        certTypeList = [
          resumeId,
          basic40Id,
          s130Id,
          s190Id,
          l180Id,
          femaIS100Id,
          femaIS700Id,
          firstAidCprId,
          wctId,
          fireHistoryId,
        ];
        break;
      case CertificateStatus.COMPLETED_RT130:
        // Required: Resume, FEMA IS-100, FEMA IS-700, First-aid CPR, Basic 40 OR (S-130 + S-190 + L-180), RT-130, WCT. Optional: fire history
        certTypeList = [
          resumeId,
          basic40Id,
          s130Id,
          s190Id,
          l180Id,
          femaIS100Id,
          femaIS700Id,
          rt130Id,
          firstAidCprId,
          wctId,
          fireHistoryId,
        ];
        break;
      default:
        certTypeList = [];
    }
    return certTypeList;
  }

  submitForm(event) {
    event.preventDefault();
    if (!this.state.canApply) {
      confirmAlert({
        title: 'Application Update Restricted',
        message:
          'You cannot update your job application as it may currently be under review or archived. Please email hr@firestormfire.com if you believe this is incorrect.',
        buttons: [
          {
            label: 'Close',
            onClick: () => {},
          },
        ],
      });
      return;
    }
    if (!util.forceVlidate(document.getElementById(page))) {
      return;
    }

    const { form } = this.state;

    const prefetchedData = this.props.api || {};
    const certStatus = prefetchedData.CertificationStatus.filter(
      (cert) => cert.id == form.certification_status,
    );

    if (!form.certification_status) {
      return confirmAlert({
        title: 'ERROR',
        message:
          "The current certification status field is required, If you don't have any training please choose No Training.",
        buttons: [
          {
            label: 'Close',
            onClick: () => {},
          },
        ],
      });
    }

    const certName = certStatus[0] ? certStatus[0].value : '';
    const certTypes = this.statusBasedCertTypeList(
      prefetchedData.ListCertificateType,
      certName,
    );
    let validCert = false;
    let errorMsg = '';
    const userCertIds = form.certificates.map(
      (cert) => parseInt(cert.type) || parseInt(cert.certificate_id),
    );

    const basic40Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.BASIC40,
    );
    const s130Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.S130,
    );
    const s190Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.S190,
    );
    const l180Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.L180,
    );
    const femaIS100Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.FEMA_IS100,
    );
    const femaIS700Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.FEMA_IS700,
    );
    const rt130Id = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.RT130,
    );
    const resumeId = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.RESUME,
    );
    const firstAidCprId = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.FIRSTAID_CPR,
    );
    const wctId = this.findTypeId(
      prefetchedData.ListCertificateType,
      CertificateType.WCT,
    );

    switch (certName) {
      case CertificateStatus.NO_TRAINING:
        validCert = userCertIds.includes(resumeId);
        errorMsg = 'You must upload your resume.';
        break;
      case CertificateStatus.NEED_RT130:
        validCert =
          userCertIds.includes(resumeId) &&
          (userCertIds.includes(basic40Id) ||
            (userCertIds.includes(s130Id) &&
              userCertIds.includes(s190Id) &&
              userCertIds.includes(l180Id))) &&
          userCertIds.includes(femaIS100Id) &&
          userCertIds.includes(femaIS700Id) &&
          userCertIds.includes(firstAidCprId);
        errorMsg =
          'You must upload all of the following required certificates: <ol><li>Resume</li><li>FEMA IS-100</li><li>FEMA IS-700</li><li>First-aid CPR</li><li>Basic 40 or a combination of S-130, S-190 and L-180</li></ol>';
        break;
      case CertificateStatus.COMPLETED_BASIC_TRAINING:
        // Check if user certificates includes all of the certificate
        validCert =
          userCertIds.includes(resumeId) &&
          (userCertIds.includes(basic40Id) ||
            (userCertIds.includes(s130Id) &&
              userCertIds.includes(s190Id) &&
              userCertIds.includes(l180Id))) &&
          userCertIds.includes(femaIS100Id) &&
          userCertIds.includes(femaIS700Id) &&
          userCertIds.includes(firstAidCprId);

        errorMsg =
          'You must upload all of the following required certificates: <ol><li>Resume</li><li>FEMA IS-100</li><li>FEMA IS-700</li><li>First-aid CPR</li><li>Basic 40 or a combination of S-130, S-190 and L-180</li></ol>';
        break;
      case CertificateStatus.COMPLETED_RT130:
        // Check if user certificates includes all of the certificate
        validCert =
          userCertIds.includes(resumeId) &&
          userCertIds.includes(rt130Id) &&
          (userCertIds.includes(basic40Id) ||
            (userCertIds.includes(s130Id) &&
              userCertIds.includes(s190Id) &&
              userCertIds.includes(l180Id))) &&
          userCertIds.includes(femaIS100Id) &&
          userCertIds.includes(femaIS700Id) &&
          userCertIds.includes(firstAidCprId) &&
          userCertIds.includes(wctId);
        errorMsg =
          'You must upload all of the following required certificates: <ol><li>Resume</li><li>RT-130</li><li>FEMA IS-100</li><li>FEMA IS-700</li><li>First-aid CPR</li><li>WCT</li><li>Basic 40 or a combination of S-130, S-190 and L-180</li></ol>';
        break;

      default:
        validCert = false;
        errorMsg = 'Unexpected Error Occurred.';
    }
    if (!validCert) {
      return confirmAlert({
        customUI: ({ title, message, onClose }) => (
          <div className='react-confirm-alert-body'>
            <h1>{title}</h1>
            {/* Use `dangerouslySetInnerHTML` to render HTML content */}
            <p dangerouslySetInnerHTML={{ __html: message }}></p>
            <div
              className='react-confirm-alert-button-group'
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <button onClick={onClose}>Close</button>
            </div>
          </div>
        ),
        title: 'ERROR',
        message: errorMsg,
        buttons: [
          {
            label: 'Close',
            onClick: () => {},
          },
        ],
      });
    }

    let formValues = Object.assign({}, this.state.form);

    'function' === typeof this.props.action &&
      this.props.action({ ...formValues, step }, step);
  }

  blur(event) {
    util.blur(event);
  }

  setValue(event) {
    if (event.target.classList.contains('aplcn-has-error')) {
      event.target.classList.remove('aplcn-has-error');
    }
    util.setValue.call(this, event);
    if (util.isblurred(event.target)) {
      var valid = util.validate(event.target);
    }
  }
  componentDidMount() {
    this.setDefaultData();
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className='react-confirm-alert-body'>
          <h1>Important</h1>
          <p>No online certificates are accepted</p>
          <div
            className='react-confirm-alert-button-group'
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <button onClick={onClose}>Got it!</button>
          </div>
        </div>
      ),
    });
  }

  componentDidUpdate(prevProps) {
    const applicationDetails =
      this.props.api && this.props.api.aplicationDetail;
    const prevApplicationDetails =
      prevProps.api && prevProps.api.aplicationDetail;
    const shouldSetDefaultValues = !!(
      (applicationDetails && applicationDetails.hash) !==
      (prevApplicationDetails && prevApplicationDetails.hash)
    );

    if (shouldSetDefaultValues) {
      this.setDefaultData();
    }
  }

  setDefaultData() {
    if (this.props.api && this.props.api.aplicationDetail) {
      var data = this.props.api.aplicationDetail,
        obj = Object.assign({}, this.state.form);
      this.setState({ certification_status_name: data.certification_status });
      this.setState({
        canApply: data.can_apply,
        form: util._merge(
          obj,
          data,
          {
            applying_position: {
              target: 'applying_position_id',
              filter: 'checkbox',
            },
            certification_status: 'certification_status_id',
            qualifications: 'general_qualification_id',
            high_school: 'highschool_name',
            school_duration: 'highschool_duration',
            school_taken: 'highschool_course',
            is_school_graduate: 'highschool_gratuate_status',
            university: 'university1',
            university1: 'university2',
            addition_info: 'applicant_info',
            certificates: 'filequalification',
          },
          (data) => {
            /*
          Callback function for modify mapped data
          */
            return this.setUniveristy(data);
          },
        ),
      });
    }
  }

  setUniveristy(obj) {
    var obj = obj || {};
    obj = util._extractObjectAndMerge(
      obj,
      {
        name: 'university',
        duration: 'degree_duration',
        course: 'degree_taken',
        gratuate_status: 'is_degree_graduate',
      },
      ['university', 'university1'],
    );
    return obj;
  }

  onDrop(acceptedFiles, type, certId) {
    if (!acceptedFiles || !acceptedFiles.length) return;

    if (certId) {
      const certIndex = this.state.form.certificates.findIndex(
        (item) => item.tempId === certId,
      );
      const certsCopy = this.state.form.certificates;
      certsCopy.splice(certIndex, 1, {
        tempId: certId,
        type: type,
        file: acceptedFiles[0],
      });
      this.setState({ form: { ...this.state.form, certsCopy } });
      return;
    }

    this.setState((prevState) => ({
      form: {
        ...this.state.form,
        certificates: [
          ...prevState.form.certificates,
          { tempId: generateRandomId(), type: type, file: acceptedFiles[0] },
        ],
      },
      uploadAreas: [],
    }));
  }

  onAddNewUploaderArea() {
    this.setState((prevState) => ({
      uploadAreas: [...prevState.uploadAreas, { id: generateRandomId() }],
    }));
  }

  onDeleteUploadedFile(file) {
    if (file.id) {
      this.removeFile(file.id, file.file_name);
      return;
    }
    let certificates = this.state.form.certificates.filter(
      (item) => item.tempId !== file.tempId,
    );
    this.setState((prevState) => ({
      form: { ...this.state.form, certificates },
    }));
  }

  onCloseUploaderArea(area) {
    let uploadAreas = this.state.uploadAreas.filter(
      (item) => item.id !== area.id,
    );
    this.setState({ ...this.state, uploadAreas: uploadAreas });
  }

  removeFile(id, name) {
    confirmAlert({
      title: 'Delete file',
      message: 'Are you sure to delete ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.dispatch(
              apis.deleteFile({
                id: id,
              }),
            );

            if (this.props.api && this.props.api.aplicationDetail) {
              const updatedFileQualifications =
                this.props.api.aplicationDetail.filequalification?.filter(
                  (file) => file.id !== id,
                );

              this.props.dispatch(
                apis.updateApi({
                  ...this.props.api.aplicationDetail,
                  filequalification: updatedFileQualifications,
                }),
              );
            }
          },
        },
        {
          label: 'No',
          onClick: () => {},
        },
      ],
    });
  }

  resetFilesAfterDeletion(id) {
    let certificates = this.state.form.certificates.filter(
      (item) => item.id !== id,
    );
    this.setState((prevState) => ({
      form: { ...this.state.form, certificates },
    }));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.api.deleteFile) {
      var obj = nextProps.api.deleteFile;
      if (util.isObject(obj)) {
        if (obj.success) {
          this.resetFilesAfterDeletion(obj.__id);
        } else {
          confirmAlert({
            title: 'Error Deleting file',
            message: util.parseMessage(obj.message),
            buttons: [
              {
                label: 'Close',
                onClick: () => {},
              },
            ],
          });
        }
      }
    }
  }

  filterCertificateList(certName, userCertIds, certificateTypeList) {
    const statusBasedCertTypes = this.statusBasedCertTypeList(
      certificateTypeList,
      certName,
    );

    let listCertificateType = certificateTypeList.filter((type) =>
      statusBasedCertTypes.includes(type.id),
    );
    for (const certId of statusBasedCertTypes) {
      if (userCertIds && userCertIds.includes(certId)) {
        listCertificateType = listCertificateType.filter(
          (type) => type.id != certId,
        );
      }
    }
    return listCertificateType;
  }

  render() {
    var prefetchedData = this.props.api || {};
    if (
      this.state.form.certification_status &&
      prefetchedData?.CertificationStatus?.findIndex(
        (item) => item.id == this.state.form.certification_status,
      ) == -1
    ) {
      prefetchedData.CertificationStatus.push({
        id: this.state.form.certification_status,
        position: this.state.form.certification_status,
        value: this.state.certification_status_name,
      });
    }

    let listCertificateType = [];
    const certStatus = prefetchedData.CertificationStatus.filter(
      (cert) => cert.id == this.state.form.certification_status,
    );
    const certName = certStatus[0] ? certStatus[0].value : '';
    let noTraining = false;
    let uploadCertMsg =
      'Upload copies of your qualification (taskbooks) and any certificates that apply to desired position.';
    const userCertIds = this.state.form.certificates.map(
      (cert) => parseInt(cert.type) || parseInt(cert.certificate_id),
    );

    if (certName) {
      if (certName == CertificateStatus.NO_TRAINING) {
        uploadCertMsg = 'Upload a copy of your resume.';
        noTraining = true;
      }
      listCertificateType = this.filterCertificateList(
        certName,
        userCertIds,
        prefetchedData.ListCertificateType,
      );
    }

    return (
      <div className='aplcn-form aplcn-form-three'>
        <form method='post' onSubmit={this.submitForm.bind(this)} id={page}>
          <div className='aplcn-form-section-head'>
            <h4>Current Certification Status*</h4>
          </div>
          <div className='aplcn-form-row-main aplcn-has-inputs'>
            <div className='row aplcn-row'>
              <div className='col-sm-12 col-md-6 aplcn-inp-wrap'>
                <select
                  className=''
                  name='form.certification_status'
                  value={this.state.form.certification_status}
                  onChange={this.setValue.bind(this)}
                  title='Certification Status'
                  required
                >
                  <option value=''>
                    {' '}
                    --- Current Certification Status ---{' '}
                  </option>
                  {prefetchedData.CertificationStatus &&
                    prefetchedData.CertificationStatus.map((item, index) => {
                      return (
                        <option
                          value={item.id}
                          key={'anticipated_location_' + item.id}
                        >
                          {item.value}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
          </div>
          {this.state.form.certification_status && (
            <>
              <div className='aplcn-form-section-head'>
                <h4>{uploadCertMsg}</h4>
              </div>
              {/* certificate upload */}
              {!this.state.form?.certificates?.length && (
                <CertificateUpload
                  certificateTypeOptions={listCertificateType}
                  onUpload={this.onDrop}
                  onAddNewUploaderArea={this.onAddNewUploaderArea}
                />
              )}

              {this.state.form?.certificates?.map((cert, index) => (
                <CertificateUpload
                  certificateTypeOptions={prefetchedData.ListCertificateType}
                  key={index}
                  onUpload={this.onDrop}
                  certificate={cert}
                  onDeleteUploadedFile={this.onDeleteUploadedFile}
                />
              ))}

              {this.state?.uploadAreas?.map((areaId, index) => (
                <CertificateUpload
                  certificateTypeOptions={listCertificateType}
                  key={index}
                  uploadAreaId={areaId}
                  onCloseUploaderArea={this.onCloseUploaderArea}
                  onUpload={this.onDrop}
                  onSelectFileType
                  onAddNewUploaderArea={this.onAddNewUploaderArea}
                />
              ))}

              {listCertificateType.length > 0 && (
                <button
                  className='upload-button'
                  onClick={this.onAddNewUploaderArea}
                  type='button'
                  disabled={
                    this.state.uploadAreas.length +
                      this.state.form?.certificates.length >=
                      20 || this.state.uploadAreas.some((area) => !area.file)
                  } //certificate upload limit is 20
                >
                  Add another certificate
                </button>
              )}
            </>
          )}

          <div className='aplcn-form-section-head'>
            <h4>Education</h4>
          </div>

          <div className='aplcn-form-section-head'>
            <h4>High School</h4>
          </div>

          <div className='aplcn-form-row-main  aplcn-has-inputs'>
            <div className='row aplcn-row'>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  required
                  placeholder='High School Name & Location*'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.high_school}
                  name='form.high_school'
                  title='High School Name & Location'
                />
              </div>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  required
                  placeholder='No. Years/Units Completed*'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.school_duration}
                  name='form.school_duration'
                  title='High School Duration'
                />
              </div>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  required
                  placeholder='Degree/Courses Taken*'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.school_taken}
                  name='form.school_taken'
                  title='High School Degree/Courses Taken'
                />
              </div>
            </div>
          </div>

          <div className='aplcn-form-section-head'>
            <h5 className='aplcn-is-graduate'>Did you graduate</h5>
          </div>
          <div className='aplcn-form-row-main'>
            <ul className='aplcn-checklist inline-radios'>
              <li>
                <input
                  value='yes'
                  type='radio'
                  id='is_school_graduate'
                  name='form.is_school_graduate'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  checked={this.state.form.is_school_graduate === 'yes'}
                />
                <label htmlFor='is_school_graduate'>
                  <span className='aplcn-check-label'>Yes</span>
                </label>
              </li>
              <li>
                <input
                  value='no'
                  type='radio'
                  id='is_school_graduate2'
                  name='form.is_school_graduate'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  checked={this.state.form.is_school_graduate !== 'yes'}
                />
                <label htmlFor='is_school_graduate2'>
                  <span className='aplcn-check-label'>No</span>
                </label>
              </li>
            </ul>
          </div>

          <div className='aplcn-form-section-head'>
            <h4>University / Tech School</h4>
          </div>

          <div className='aplcn-form-row-main  aplcn-has-inputs'>
            <div className='row aplcn-row'>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  placeholder='University/tech name and location'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.university}
                  name='form.university'
                />
              </div>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  placeholder='No. years/units completed'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.degree_duration}
                  name='form.degree_duration'
                />
              </div>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  placeholder='Degree/course taken'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.degree_taken}
                  name='form.degree_taken'
                />
              </div>
            </div>
          </div>

          <div className='aplcn-form-section-head'>
            <h5 className='aplcn-is-graduate'>Did you graduate</h5>
          </div>
          <div className='aplcn-form-row-main'>
            <ul className='aplcn-checklist inline-radios'>
              <li>
                <input
                  value='yes'
                  type='radio'
                  id='is_degree_graduate88'
                  name='form.is_degree_graduate'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  checked={this.state.form.is_degree_graduate === 'yes'}
                />
                <label htmlFor='is_degree_graduate88'>
                  <span className='aplcn-check-label'>Yes</span>
                </label>
              </li>
              <li>
                <input
                  value='no'
                  type='radio'
                  id='is_degree_graduate222'
                  name='form.is_degree_graduate'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  checked={this.state.form.is_degree_graduate !== 'yes'}
                />
                <label htmlFor='is_degree_graduate222'>
                  <span className='aplcn-check-label'>No</span>
                </label>
              </li>
            </ul>
          </div>

          <div className='aplcn-form-section-head'>
            <h4>University / Tech School</h4>
          </div>

          <div className='aplcn-form-row-main  aplcn-has-inputs'>
            <div className='row aplcn-row'>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  placeholder='University/tech name and location'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.university1}
                  name='form.university1'
                />
              </div>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  placeholder='No. years/units completed'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.degree_duration1}
                  name='form.degree_duration1'
                />
              </div>
              <div className='col-sm-12 col-md-4 aplcn-inp-wrap'>
                <input
                  type='text'
                  placeholder='Degree/course taken'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.degree_taken1}
                  name='form.degree_taken1'
                />
              </div>
            </div>
          </div>

          <div className='aplcn-form-section-head'>
            <h5 className='aplcn-is-graduate'>Did you graduate</h5>
          </div>
          <div className='aplcn-form-row-main'>
            <ul className='aplcn-checklist inline-radios'>
              <li>
                <input
                  value='yes'
                  type='radio'
                  id='is_degree_graduate107'
                  name='form.is_degree_graduate1'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  checked={this.state.form.is_degree_graduate1 === 'yes'}
                />
                <label htmlFor='is_degree_graduate107'>
                  <span className='aplcn-check-label'>Yes</span>
                </label>
              </li>
              <li>
                <input
                  value='no'
                  type='radio'
                  id='is_degree_graduate16377'
                  name='form.is_degree_graduate1'
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  checked={this.state.form.is_degree_graduate1 !== 'yes'}
                />
                <label htmlFor='is_degree_graduate16377'>
                  <span className='aplcn-check-label'>No</span>
                </label>
              </li>
            </ul>
          </div>

          <div className='aplcn-form-section-head'>
            <h4>Additional Information</h4>
          </div>

          <div className='aplcn-form-row-main  aplcn-has-inputs'>
            <p className='aplcn-desc'>
              Present below any other information which relates to your ability
              to perform the job for which you are applying such as licenses,
              memberships, language skills, academic and athletic achievements,
              community involvement, and volunteer experiences. Leave out
              information indicating religion, gender or any other protected
              category.
            </p>
            <div className='aplcn-note-text-wrapper'>
              <textarea
                name='form.addition_info'
                placeholder='Please enter additional information here…'
                value={this.state.form.addition_info}
                onChange={this.setValue.bind(this)}
                onBlur={this.blur.bind(this)}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 aplcn-form-main-actionbar'>
              <div className='aplcn-form-actionbar'>
                <button
                  onClick={this.back.bind(this)}
                  type='button'
                  disabled=''
                  className='aplcn-prev-button'
                >
                  Previous
                </button>
                <button type='submit' className='aplcn-next-btn'>
                  Next
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
  back(event) {
    event.preventDefault();
    this.props.back(step);
  }
}
function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Qualification);
export { connectedApp as Qualification };
